import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthService, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('access_token_admin');
    const companyId = this.getCompanyId();

    if (token && token !== 'temporal') {
      request = request.clone({
        setHeaders: {
          token,
          company_id: companyId,
          language_id: '1',
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const refresh_token = sessionStorage.getItem('refresh_token_admin');

        if (!token) {
          this.router.navigate(['/login']);
          return throwError(error);
        }

        if (
          request.url.includes('refresh-token') ||
          request.url.includes('login') ||
          request.url.includes('logout')
        ) {
          if (request.url.includes('refresh-token')) {
            this.authService.logout();
          }
          return throwError(error);
        }

        if (error.status !== 403) {
          return throwError(error);
        }

        if (this.refreshTokenInProgress) {
          return this.refreshTokenSubject.pipe(
            filter((result) => result != null),
            take(1),
            switchMap(() => next.handle(this.addAuthenticationToken(request)))
          );
        } else {
          this.refreshTokenInProgress = true;
          this.refreshTokenSubject.next(null);

          return this.authService.refreshTokenV1(token).pipe(
            switchMap((res: any) => {
              this.refreshTokenInProgress = false;
              sessionStorage.setItem('access_token_admin', res);
              this.refreshTokenSubject.next(res);
              return next.handle(this.addAuthenticationToken(request));
            }),
            catchError((err) => {
              this.refreshTokenInProgress = false;
              this.authService.logout();
              return throwError(error);
            })
          );
        }
      })
    );
  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    const accessToken = sessionStorage.getItem('access_token_admin');
    const companyId = this.getCompanyId();

    if (!accessToken) return request;

    return request.clone({
      setHeaders: {
        token: accessToken,
        company_id: companyId,
        language_id: '1',
      },
    });
  }

  private getCompanyId(): string {
    try {
      const raw = localStorage.getItem('company_info');
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.company_id) {
          return parsed.company_id.toString();
        }
      }
    } catch (err) {
      console.warn("⚠️ company_info inválido:", err);
    }

    // Fallback
    return localStorage.getItem('companyIDTemp') || localStorage.getItem('company_id')||"";
  }
}


